module.exports = __webpack_public_path__ + "img/suzuki-vitara.ac556255.jpg";